import axios from "axios";
import TokenService from "./token.service";

const baseURL = process.env.REACT_APP_API_URL;

const examAPI = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

examAPI.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

examAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error?.config || error?.response?.config;

    if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
      return Promise.reject(error);
    }

    if (error?.message === "Network Error" || error?.toJSON?.().message === "Network Error") {
      return Promise.reject(error);
    }

    if (!error?.response) {
      return Promise.reject(error);
    }

    const isIgnoredEndpoint = ["/auth/login", "/core/transfer_students/"].some((endpoint) =>
      originalConfig?.url?.includes(endpoint)
    );
    const isRefreshEndpoint = originalConfig?.url?.includes("/auth/refresh/");

    if (isIgnoredEndpoint || isRefreshEndpoint || error.response.status !== 401 || originalConfig?._retry) {
      return Promise.reject(error);
    }

    const refreshToken = TokenService.getLocalRefreshToken();
    if (!refreshToken) {
      TokenService.removeTokens();
      window.dispatchEvent(new Event("session-expired"));
      return Promise.reject(error);
    }

    originalConfig._retry = true;

    try {
      const rs = await axios.post(`${baseURL}/auth/refresh/`, {
        refresh: refreshToken,
      });
      const token = rs.data.access;
      TokenService.updateLocalAccessToken(token);
      return examAPI(originalConfig);
    } catch (refreshError) {
      TokenService.removeTokens();
      window.dispatchEvent(new Event("session-expired"));
      return Promise.reject(refreshError);
    }
  }
);

export default examAPI;
